const PERMISSION_KEY= "company:bc_industry";
const PAGE_URL = {
    B_C_INDUSTRY_PAGE: "/admin/company/bc-industry"
}

export {PERMISSION_KEY, PAGE_URL}

